import { Container, ContainerItem } from '../common/container/Container'
import { ExerciseAlgorithmService } from '../modules/exerciseAlgorithm/services/ExerciseAlgorithm'
import {
  EXERCISEALGORITHM_API_KEY,
  EXERCISEALGORITHM_SERVICE_KEY,
  EXERCISEALGORITHM_MODULE,
  AlgorithmExerciseProps,
} from '../modules/exerciseAlgorithm/container'
import { ExerciseAlgorithmApi } from '../modules/exerciseAlgorithm/api/ExerciseAlgorithm'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'

let container: Container

function init(p: AlgorithmExerciseProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(EXERCISEALGORITHM_API_KEY, new ContainerItem({ instance: new ExerciseAlgorithmApi() }))

  items.set(
    EXERCISEALGORITHM_SERVICE_KEY,
    new ContainerItem({
      instance: new ExerciseAlgorithmService({ apiKey: EXERCISEALGORITHM_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getExerciseAlgorithmContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[EXERCISEALGORITHM_MODULE],
      },
    })
  }

  return container
}
